import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Row, Col, Input, Button, Card, Avatar, Flex, Tooltip } from 'antd';
import Swal from 'sweetalert2';
import axios from 'axios';
import DynamicTable2 from './CorporateDynamicTable';
import solve from '../../component/image/solve.svg';
import '../../component/Allcss/stylecorp.css';
import { UserOutlined, SendOutlined } from '@ant-design/icons';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import { BASE_URL } from "../../App";
import relativeTime from 'dayjs/plugin/relativeTime';
import {  Backdrop, CircularProgress } from '@mui/material';

dayjs.extend(relativeTime);
const AccordionExpandDefault = () => {
  const [expanded, setExpanded] = useState('panel1');
  const [call, setCall] = useState('');
  const [severity, setSeverity] = useState('');
  const [selectCall, setSelectCall] = useState([]);
  const [query, setQuery] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [dataTable, setDataTable] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [viewData, setViewData] = useState(null);
  const [isViewPopupOpen, setIsViewPopupOpen] = useState(false);
  const [selectComments, setSelectComments] = useState([]);
  const { TextArea } = Input;
  const login_id = localStorage.getItem('USER_ID');

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);


  const formatChatDate = (chatDate) => {
    const now = dayjs();
    const date = dayjs(chatDate);
    const diffInSeconds = now.diff(date, 'second');
    const diffInMinutes = now.diff(date, 'minute');
    const diffInHours = now.diff(date, 'hour');
    const diffInDays = now.diff(date, 'day');
    const diffInMonths = now.diff(date, 'month');
    const diffInYears = now.diff(date, 'year');

    if (diffInSeconds < 60) {
      return `${diffInSeconds}s`;
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes}m ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours}h ago`;
    } else if (diffInDays < 30) {
      return `${diffInDays}d ago`;
    } else if (diffInMonths < 12) {
      return `${diffInMonths}mo ago`;
    } else {
      return `${diffInYears}y ago`;
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(BASE_URL + '/existingcall', {
          login_id: login_id,
          dealer_code: login_id,
        });
  
        if (response.status === 200) {
          const enhancedData = response.data.data.map((item) => {
            let buttonLabel = 'SOLVED';
            let buttonColor = 'linear-gradient(to right, #26C107 0%, #C1F5B7 100%)';
  
            if (item.status !== "2") {
              buttonLabel = 'OPEN';
              buttonColor = 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)';
            }
  
            return {
              ...item,
              STATUS: (
                <button
                  style={{
                    background: buttonColor,
                    color: 'black',
                    borderRadius: '5px',
                    fontWeight: 'bold',
                    width: '90px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '8px',
                    boxSizing: 'border-box',
                  }}
                  onClick={() => handleViewClick(item)}
                  variant="contained"
                >
                  {buttonLabel}
                </button>
              ),
              PARTICULARS: (
                <div
                  style={{
                    maxWidth: '300px', 
                    overflow: 'visible', 
                    wordWrap: 'break-word', 
                    whiteSpace: 'normal', 
                  }}
                >
                  {item.PARTICULARS}
                </div>
              ),
            };
          });
  
          let newData = enhancedData.map(item => {
            const { status, ...rest } = item;
            return rest;
          });
          setDataTable(newData);
        }
      } catch (error) {
        handleApiError(error);
      }
    };
    fetchData();
  }, [refresh]);
  
  useEffect(() => {
    const fetchCallNature = async () => {
      try {
        const response = await axios.post(BASE_URL + '/callnature', {}, {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('Token') },
        });
        setSelectCall(response.data.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchCallNature();
  }, []);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const resetForm = () => {
    setMobileNo('');
    setCall('');
    setQuery('');
    setSeverity('');
  };

  const handleCancel = () => {
    resetForm();
  };

  const handleSave = async () => {
    setLoading(true);
    setOpen(true);

    try {
      const response = await axios.post(BASE_URL + '/createnewcall', {
        login_id: login_id,
        alternate_number: mobileNo,
        call_nature: call,
        query: query,
        severity: severity,
        dealer_code: login_id,
      }, {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('Token') },
      });

      if (response.status === 200) {
        setRefresh(prev => prev + 1);
        resetForm();
        setExpanded('panel2');
        Swal.fire({ title: response.data.data, icon: 'success', confirmButtonText: 'OK' });
      } else {
        Swal.fire({ title: response.data.data, icon: 'warning', confirmButtonText: 'OK' });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: error.response?.data?.message || error.message || 'An error occurred.',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  const handleViewClick = (item) => {
    setViewData(item);
    setIsViewPopupOpen(true);
  };

  const closeViewPopup = () => {
    setIsViewPopupOpen(false);
    setViewData(null);
    setRefresh(prev => prev + 1);
  };

  const handleApiError = (error) => {
    console.error('Error:', error);
    const message = error.response
      ? `Error: ${error.response.data.message}`
      : 'An unexpected error occurred. Please try again.';
    Swal.fire({ icon: 'warning', text: message });
  };

  const ViewDataPopup = () => {
    const [commentText, setCommentText] = useState('');
    const [selectComments, setSelectComments] = useState([]);
    const [refresh1, setRefresh1] = useState(0);
    const dialogContentRef = useRef(null);

    useEffect(() => {
      if (isViewPopupOpen && dialogContentRef.current) {
        dialogContentRef.current.scrollTop = dialogContentRef.current.scrollHeight;
      }
    }, [isViewPopupOpen, selectComments]);

    const handleChange = useCallback((id, value) => {
      setCommentText(prevQueries => ({
        ...prevQueries,
        [id]: value
      }));
    }, []);

    const handleSubmit = async () => {
      try {
        const response = await axios.post(BASE_URL + '/commentinsert', {
          login_id: login_id,
          call_id: viewData.CALL_NO,
          msg: commentText[viewData.CALL_NO] || '',
          dealer_code: login_id,
        }, {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('Token') },
        });
        if (response.status === 200) {
          setRefresh1(prev => prev + 1);
          setIsViewPopupOpen(true);
          setCommentText('');
          // alert("test1");
        } else {
          Swal.fire({ title: response.data.data, icon: 'warning', confirmButtonText: 'OK' });
        }
      } catch (error) {
        setIsViewPopupOpen(false);
        console.error(error);
        Swal.fire({
          title: error.response?.data?.message || error.message || 'An error occurred.',
          icon: 'warning',
          confirmButtonText: 'OK'
        });
      }
    };

    useEffect(() => {
      const fetchComments = async () => {
        try {
          const response = await axios.post(BASE_URL + '/viewcomments', {
            login_id: login_id,
            call_id: viewData.CALL_NO,
          });
          setSelectComments(response.data.data);
        } catch (error) {
          console.error('Error fetching comments:', error);
        }
      };
      fetchComments();
    }, [refresh1, viewData.CALL_NO]);
    const getCardClassName = (user_id_d) => {
      switch (user_id_d) {
        case "1":
          return "card-red";
        case "2":
          return "card-green";
        default:
          return "card-blue";
      }
    };

    const getTextColor = (user_id_d) => {
      const charCode = user_id_d.charCodeAt(0);
    };
    const background = (user_id_d) => {
      switch (user_id_d) {
        case "1":
          return "#EE0F65";
        case "2":
          return "#4a7907";
        default:
          return "#094eb1";
      }
    };
    const customCardStyles = {
      position: 'relative',
      // clipPath: 'polygon(0% 0%, 0% 0%, 100% 0%, 100% 100%, 100% 100%, 0% 100%, 3% 85%)',
      clipPath: 'polygon(0% 0%, 2% 15%, 0% 900%, 0% 100%, 100% 100%, 100% 0%)',
      padding: '0px',
      borderRadius: '10px',
      overflow: 'hidden',
      marginBottom: '20px',
      width: 'fit-content',
      maxWidth: '65%',
    };

    const formatDate = (dateString) => {
      const chatDate = new Date(dateString);
      return chatDate.toISOString().split('T')[0];
    };

    return (
      <Dialog
        open={isViewPopupOpen}
        onClose={closeViewPopup}
        PaperProps={{ sx: { width: '80%', maxWidth: 'md' } }}
      >
        <DialogTitle>
          <IconButton
            edge="end"
            color="inherit"
            onClick={closeViewPopup}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
          Call ID: {viewData.CALL_NO}
        </DialogTitle>
        <DialogContent ref={dialogContentRef} style={{ padding: '16px' }}>
          {selectComments.map(comment => {
            const isLeftAligned = comment.user_id_d !== login_id;
            return (
              <div
                key={comment.id_no}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  marginBottom: '20px',
                  justifyContent: isLeftAligned ? 'flex-start' : 'flex-end',
                }}
              >
                {comment.user_id_d !== login_id && (
                  <Avatar
                    style={{
                      backgroundColor: background(comment.user_id_d),
                      color: 'white',
                      fontWeight: 'bold',
                      margin: isLeftAligned ? '0 10px 0 0' : '0 0 0 10px',
                      alignSelf: 'flex-start',
                    }}
                  >
                    {comment.USER_NAME.charAt(0)}
                  </Avatar>
                )}
                <Card
                  style={{
                    ...customCardStyles,
                    marginLeft: isLeftAligned ? '10px' : '0',
                    marginRight: isLeftAligned ? '0' : '10px',
                    alignSelf: 'flex-start',
                    maxWidth: '70%',
                  }}
                  className={`card ${getCardClassName(comment.user_id_d)}`}
                >
                  <Card.Meta
                    description={
                      <>
                        <div style={{ marginBottom: '5px', color: '#333' }}><b style={{ color: background(comment.user_id_d) }}>{comment.USER_NAME}: </b>{comment.MSG}</div>
                        <div style={{ fontWeight: 'bold', color: '#515A5A', textAlign: 'right' }}>{formatChatDate(comment.CHATDATE)}</div>
                      </>
                    }
                  />
                </Card>
              </div>
            );
          })}
        </DialogContent>
        <div style={{ marginBottom: '20px', padding: '5px' }}>
          <Row gutter={16}>
            <Col span={20} >
              {viewData.status !== "2" ? (
                <TextArea
                  value={commentText[viewData?.CALL_NO] || ''}
                  onChange={(e) => handleChange(viewData?.CALL_NO, e.target.value)}
                  placeholder="Add your comments"
                  style={{ borderRadius: '20px', width: '100%' }}
                />
              ) : (
                <Typography
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    color: 'green',
                    fontWeight: 'bold',

                  }}
                >
                  <img src={solve} style={{ width: '40px', height: 'auto', }} alt="Solved" />
                  <span>Solved</span>
                </Typography>
              )}
            </Col>
            {viewData.status !== "2" && (
              <Col span={4} style={{ textAlign: 'center' }}>
                <Button
                  shape="circle"
                  icon={<SendOutlined />}
                  onClick={handleSubmit}
                  style={{
                    width: '50%',
                    height: '90%',
                    background: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)',
                    color: 'black',
                    fontWeight: 'bold',
                  }}
                />
              </Col>
            )}
          </Row>
        </div>
      </Dialog>

    );
  };
  return (
    <>
      <h3 style={{ fontWeight: 'bold', textDecoration: 'underline', textAlign: 'center' }}> </h3>
      <div className='container'>
        <Accordion expanded={expanded === 'panel1'} onChange={handleAccordionChange('panel1')} defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header" sx={{ backgroundColor: '#61d1e5' }}>
            <Typography style={{ fontWeight: 'bold' }}>NEW CALLS</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <br></br>
              <Row>
                <Col span={7} style={{ fontWeight: 'bold', textAlign: 'center' }}>Call Nature :</Col>
                <Col span={17}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Call Nature</InputLabel>
                    <Select value={call} label="Call Nature" onChange={(e) => setCall(e.target.value)}>
                      {selectCall.map((item) => (
                        <MenuItem key={item.id_no} value={item.id_no.toLowerCase()}>{item.call_nature}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Col>
              </Row>
              <br />
              <Row>
                <Col span={7} style={{ fontWeight: 'bold', textAlign: 'center' }}>Severity :</Col>
                <Col span={17}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Severity</InputLabel>
                    <Select value={severity} label="Severity" onChange={(e) => setSeverity(e.target.value)}>
                      <MenuItem value="low">Low</MenuItem>
                      <MenuItem value="medium">Medium</MenuItem>
                      <MenuItem value="high">High</MenuItem>
                      <MenuItem value="veryhigh">Very High</MenuItem>
                    </Select>
                  </FormControl>
                </Col>
              </Row>
              <br />
              <Row>
                <Col span={7} style={{ fontWeight: 'bold', textAlign: 'center' }}>Alternate Number :</Col>
                <Col span={17}>
                  <TextField
                    fullWidth
                    required
                    label="Alternate Number"
                    name="mobile"
                    id="mobile"
                    size="small"
                    value={mobileNo}
                    onChange={(e) => /^\d{0,10}$/.test(e.target.value) && setMobileNo(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ maxLength: 10, pattern: "\\d*" }}
                  />
                </Col>
              </Row>
              <br />
              <Row>
                <Col span={7} style={{ fontWeight: 'bold', textAlign: 'center' }}>Query :</Col>
                <Col span={17}>
                  <Input.TextArea
                    rows={5}
                    placeholder='Enter text...'
                    name='query'
                    id='query'
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                  />
                </Col>
              </Row>
              <br />
              <center>
              
                  <Button
                    onClick={handleSave}
                    style={{
                      background: 'linear-gradient(to right, #2e7fc2 0%, #6acad2 100%)',
                      color: 'black',
                      width: '40%',
                      fontWeight: 'bold',
                      marginRight: '20px',
                    }}
                    variant="contained"
                  >
                    SAVE
                  </Button>

                  <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
                    <CircularProgress color="inherit" />
                  </Backdrop>
                

                <Button
                  onClick={handleCancel}
                  style={{
                    background: 'linear-gradient(to right, rgb(255 0 0) 0%, rgb(243 138 174) 100%)',
                    color: 'black',
                    width: '40%',
                    fontWeight: 'bold',
                  }}
                  variant="contained"
                >
                  CANCEL
                </Button>
              </center>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <br />
        <Accordion expanded={expanded === 'panel2'} onChange={handleAccordionChange('panel2')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2-content" id="panel2-header" sx={{ backgroundColor: '#61d1e5' }}>
            <Typography style={{ fontWeight: 'bold' }}>EXISTING CALLS</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <DynamicTable2 data={dataTable} onViewClick={handleViewClick} />
              {isViewPopupOpen && <ViewDataPopup />}
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};
export default AccordionExpandDefault;
